import { parseResponse } from './response'
import type { ApiClient } from '@fusapp-work/api'
import { z } from 'zod'
import { createCompanySchema, type NewCompany } from '../companies/domain/company'
export const organizationSchema = z.object({ id: z.string().min(1), name: z.string(), legalName: z.string(), countryCode: z.string() })
export type Organization = z.infer<typeof organizationSchema>
const pageSchema = z.object({ items: z.array(organizationSchema), pageNo: z.number(), pageSize: z.number(), totalCount: z.number(), totalPage: z.number(), isMoreRecords: z.boolean() })
export function createOrganizationApi(client: ApiClient) {
  return {
    async list(signal?: AbortSignal): Promise<Organization[]> {
      const organizations: Organization[] = []
      let pageNo = 1
      for (;;) {
        const page = parseResponse(pageSchema, await client.request<unknown>(`/api/v1/organization/list?pageNo=${pageNo}&pageSize=100`, { signal }))
        organizations.push(...page.items)
        if (!page.isMoreRecords) return organizations
        if (!page.items.length || pageNo >= 1000) throw new Error('Invalid organization pagination')
        pageNo += 1
      }
    },
    async create(input: NewCompany, signal?: AbortSignal): Promise<Organization> {
      return parseResponse(organizationSchema, await client.request<unknown>('/api/v1/organization', { method: 'POST', body: createCompanySchema.parse(input), signal }))
    },
  }
}
